import { CMP_PREFIX } from "@/base/constant";
import type { GetProps } from "antd";
import { Skeleton as AntdSkeleton } from "antd";

export type SkeletonNodeProps = Partial<GetProps<typeof AntdSkeleton.Node>>;
export type SkeletonImageProps = Partial<GetProps<typeof AntdSkeleton.Image>>;
export type SkeletonAvatarProps = Partial<GetProps<typeof AntdSkeleton.Avatar>>;
export type SkeletonInputProps = Partial<GetProps<typeof AntdSkeleton.Input>>;

export const skeletonPrefixCls = `${CMP_PREFIX}-skeleton`;

export const SkeletonNode = ({ ...props }: SkeletonNodeProps) => {
  return <AntdSkeleton.Node {...props} />;
};

export const SkeletonImage = ({ ...props }: SkeletonImageProps) => {
  return <AntdSkeleton.Image {...props} />;
};

export const SkeletonAvatar = ({ ...props }: SkeletonAvatarProps) => {
  return <AntdSkeleton.Avatar {...props} />;
};

export const SkeletonInput = ({ ...props }: SkeletonInputProps) => {
  return <AntdSkeleton.Input {...props} />;
};
